import type { FC } from 'react';

import './EmptyCalendarState.scss';

export const EmptyCalendarState: FC = () => (
  <div className="EmptyCalendarState" data-testid="empty-calendar-state">
    <div className="EmptyCalendarState__message">
      На текущую дату нет графика работы исполнителей и записей
    </div>
  </div>
);
